import { Box, Button, Pagination, SxProps, Typography } from "@mui/material"
import { UserProps } from "./types"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { ActivityAccordionList } from "../../activityAccordionList"
import { ScrollContainer } from "../../../../../../../../components/scrollContainer"
import Loader from "../../../../../../../../components/loader"
import { NoResponse } from "../../../../../../../../components/errors/noResponse"

export const UserActivity = ({ userList, changeExpandMap, usersToDisplayed, usersToView, hiddeAll, seeAll, manualPagination, loading, displayActivityListUsers, menuOption, getActivities, query, expandMap }: UserProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    return (
        <>
            {!!loading && <Loader />}

            {
                !loading && (
                    <>
                        <Box sx={styles.container}>
                            <Box sx={{ ...styles.alignHorizontal, ...styles.wFull } as SxProps}>
                                <Box sx={styles.header}>
                                    <Typography variant="title_grey_big">{t('loogbook.titles.activityList')}</Typography>

                                    <Box sx={styles.allButons}>
                                        <Button sx={styles.seeButons} onClick={seeAll}>{t('loogbook.buttons.seeAll')}</Button>
                                        <Button sx={styles.seeButons} onClick={hiddeAll}>{t('loogbook.buttons.hiddenAll')}</Button>
                                        {!expandMap && <Button sx={styles.seeButons} onClick={changeExpandMap}>{expandMap ? t('loogbook.buttons.hiddenMap') : t('loogbook.buttons.seeMap') }</Button>}
                                    </Box>
                                </Box>

                            </Box>
                            <ScrollContainer maxHeight="600px" sx={styles.list}>
                                {
                                    userList && userList.map(userActivity => (
                                        <ActivityAccordionList
                                            key={userActivity.id}
                                            types={userActivity.types}
                                            userId={userActivity.id}
                                            usersToDisplayed={usersToDisplayed}
                                            usersToView={usersToView}
                                            isVisible={!usersToDisplayed.some(userId => userId == userActivity.id)}
                                            visibility={{
                                                color: 'primary', onClick: (e) => {
                                                    e.stopPropagation()
                                                    displayActivityListUsers({ users: userActivity.id, list: true })
                                                }
                                            }}
                                            id={userActivity.id}
                                            displayActivityListUsers={displayActivityListUsers}
                                            amount={userActivity.amount}
                                            title={userActivity.userName}
                                            menuOption={menuOption}
                                            list={userActivity.activityList ?? []}
                                            completedLogs={userActivity.completedLogs}
                                            area={userActivity.area ?? []}
                                            curp={userActivity.curp ?? ''}
                                            deaprtment={userActivity.department ?? []}
                                            division={userActivity.division ?? ''}
                                            role={userActivity.role ?? ''}
                                            getActivities={getActivities}
                                            query={query}
                                        />
                                    ))
                                }
                                {!userList.length && <NoResponse label={t('general.noActivities')} />}
                            </ScrollContainer>
                            <Box sx={styles.footer}>
                                {!!(manualPagination.totalPages > 1) &&
                                    <Pagination
                                        page={manualPagination.page}
                                        sx={styles.pagination}
                                        count={manualPagination.totalPages}
                                        onChange={(_, page) => {
                                            manualPagination.changePagination({ page, })
                                        }}
                                        showFirstButton
                                        showLastButton
                                    />
                                }
                            </Box>
                        </Box>
                    </>
                )
            }



        </>
    )
}